module.exports = __webpack_public_path__ + "img/Academy_icon.8f8f7ef1.png";